import { Formik, Form, useField } from "formik";
import apiFetch from "@wordpress/api-fetch";
import * as Yup from "yup";
import { useState } from "@wordpress/element";
import { Input } from "./form";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";

const NlForm = () => {
  return (
    <>
      <GoogleReCaptchaProvider reCaptchaKey="6LfFR7ciAAAAAAjzaR-MgyoRXqlLqv0hFBF81jLo">
        <MyNlForm />
      </GoogleReCaptchaProvider>
    </>
  );
};

const FormWrapper = ({ isSubmitting, isValid, message }) => {
  return (
    <>
      <Form>
        <div className="input-wrapper">
          <Input
            label="Email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="votre.nom@exemple.com"
            size={100}
            showLabel={false}
          />
        </div>
        <button disabled={isSubmitting || !isValid} type="submit">
          Je m’abonne !
        </button>
      </Form>
      {message && message.length > 0 && (
        <span className="nl-form-msg">{message}</span>
      )}
      {isSubmitting && <span className="nl-form-msg">Envoi en cours…</span>}
    </>
  );
};

const MyNlForm = () => {
  const [message, setMessage] = useState("");
  const { executeRecaptcha } = useGoogleReCaptcha();
  return (
    <Formik
      initialValues={{
        email: "",
      }}
      validationSchema={Yup.object({
        email: Yup.string().email("Adresse e-mail invalide").required("Requis"),
      })}
      onSubmit={async (values, { setSubmitting, resetForm }) => {
        if (!executeRecaptcha) {
          setMessage(
            "Une erreur s’est produite avec les vérification de sécurité."
          );
          console.log("Execute recaptcha not yet available");
          return;
        }
        const token = await executeRecaptcha("nl_form");
        apiFetch({
          path: `/fleuriaye/v1/nl_form`,
          method: "POST",
          data: { ...values, token, action: "nl_form" },
        }).then((res) => {
          setSubmitting(false);
          if (res?.response?.status === 200) {
            setMessage(res?.response?.data?.message);
            resetForm();
          }
        });
      }}
      children={(formikProps) => (
        <FormWrapper {...formikProps} message={message} />
      )}
    ></Formik>
  );
};

export default NlForm;
